import { ITreeviewLopFocusedValue } from "../../../components-data/treeview-lop/TreeviewLop";
import { IDongBoHocPhiRequest } from "../../../model/request/dong-bo/IDongBoHocPhiRequest";
import { IProcessRequest } from "../../../model/request/IProcessRequest";
import { IDongBoHocPhiSinhVien } from "../../../model/respone/dong-bo/IDongBoHocPhiSinhVien";
import {
  IHoanVeViRequest,
  IHoanVeViXemTruocRequest,
} from "../../../model/request/dong-bo/IHoanVeViRequest";
import { IHoanVeViKhoan } from "../../../model/respone/report/ISoDuSinhVienDashboard";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const edongBoHocPhiActionsObj = {
  LOAD_START: {} as IDongBoHocPhiRequest,
  LOAD_SUCCESS: {} as IDongBoHocPhiSinhVien[],
  LOAD_ERRR: {} as string,

  SHOW_HIDE_VIEW_LOP_TIN_CHI: {} as string,

  CHANGE_FOCUS_TREEVIEW_VALUE: {} as ITreeviewLopFocusedValue | undefined,
  CHANGE_DISPLAY_MODE: {} as "full" | "popup",

  CHANGE_SINHVIEN_SELECTED_IDS: {} as string[],
  SYNC_START: {} as IProcessRequest<IDongBoHocPhiRequest>,
  SYNC_SUCCESS: {} as IDongBoHocPhiSinhVien[],
  SYNC_ERR: {} as string,

  CHANGE_REQUEST: {} as any,

  CLOSE_PROCESSING_MODAL: undefined,

  // Hoàn về ví hàng loạt (khoản ví đã trả quay lại ví, giữ chờ lập phiếu chi).
  HOAN_VE_VI_SHOW_MODAL: {} as boolean,
  HOAN_VE_VI_LOAD_START: {} as IHoanVeViXemTruocRequest,
  HOAN_VE_VI_LOAD_SUCCESS: {} as IHoanVeViKhoan[],
  HOAN_VE_VI_LOAD_ERR: {} as string,
  HOAN_VE_VI_CHANGE_SELECTED_IDS: {} as string[],
  HOAN_VE_VI_START: {} as IProcessRequest<IHoanVeViRequest>,
  HOAN_VE_VI_SUCCESS: {} as string,
  HOAN_VE_VI_ERR: {} as string,
  HOAN_VE_VI_CLOSE_PROCESSING: undefined,
};

export const eDongBoHocPhiActionTypeIds = generateActionTypeIds(
  edongBoHocPhiActionsObj,
  "DONG_BO_HOC_PHI",
);
export type IDongBoHocPhiActionTypes = IGenericActionType<
  typeof edongBoHocPhiActionsObj,
  "DONG_BO_HOC_PHI"
>;
